window.calendar = {
    daysOfStayLimitMax: 28,
    maxFutureDays: 500 - 1,
    addDays: function(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    },
    diffDays: function (date1, date2, allowNegative) {
        var timeDiff = date2.getTime() - date1.getTime();
        if (!allowNegative) timeDiff = Math.abs(timeDiff);
        return Math.ceil(timeDiff / (1000 * 3600 * 24)); 
    },
    parseDate: function (input) {
      var parts = input.split('-');
      if (parts[0].length == 4)
        return new Date(parts[0], parts[1]-1, parts[2]); // Note: months are 0-based
      else 
        return new Date(parts[2], parts[1]-1, parts[0]);
    },
    validateDates: function(start, end) {
        var datStart = win.calendar.parseDate(start),
            datEnd =  win.calendar.parseDate(end),
            datToday = win.calendar.parseDate(win.store.state.today);
        if (win.calendar.diffDays(datToday, datStart, true) < 0 || win.calendar.diffDays(datToday, datEnd, true) < 0 ){
            return ({ valid: false, errorType: 'datesPast' });
        } else if (win.calendar.diffDays(datEnd, datStart) > win.calendar.daysOfStayLimitMax ) {
            return ({ valid: false, errorType: 'datesApart' });
        } else if( datEnd <= datStart) {
            return ({ valid: false, errorType: 'datesMismatch' });
        }
        return ({valid: true});
    },
    setSyncedCalendars: function(range) {
        range = range || win.calendar.getDatesFromShareState();
        win.store.state.syncCalendars.forEach(function(calendar) {
            calendar.start.setDate(range.start, true, true, true);
            calendar.start.setRange({start: range.start, end: range.end});
            calendar.end.setDate(range.end, true, true, true);
            calendar.end.setRange({start: range.start, end: range.end});
        });
    },
    getDatesFromShareState: function() {
        var sharedState = win.store.state,
            today = win.calendar.today(),
            tomorrow = win.calendar.tomorrow(),
            dayAfterTomorrow = win.calendar.dayAfterTomorrow(),
            startDate = sharedState.query.start ? win.calendar.parseDate(sharedState.query.start) : null,
            endDate = sharedState.query.end ? win.calendar.parseDate(sharedState.query.end) : null;
            if (!startDate || !endDate || startDate < today || endDate <= startDate || win.calendar.diffDays(endDate, startDate) > win.calendar.daysOfStayLimitMax) {
                startDate = isMobile ? today : tomorrow;
                endDate = isMobile ? tomorrow : dayAfterTomorrow;
            }
        return { start: startDate, end: endDate };
    },
    getYMD: function(date) {
        return date.getFullYear() + '-' + ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    },
    updateSharedState: function(startDate, endDate) {
        if (win.store) {
            win.store.set('startSelect', win.calendar.getYMD(startDate));
            win.store.set('endSelect', win.calendar.getYMD(endDate));
        }
    },
    today: function() {
        return win.calendar.parseDate(win.store.state.today);
    }, 
    tomorrow: function() {
        return win.calendar.addDays(win.calendar.today(),1);
    },
    dayAfterTomorrow: function() {
        return win.calendar.addDays(win.calendar.today(), 2);
    },
    isUSdate: function() {
        return win.store.state.country == "us";
    },
    fullDateString: function (date) {
        var day = date.getDate(),
            month = date.getMonth(),
            weekDay = date.getDay(),
            dayName = i18n.weekdaysShort[weekDay],
            monthName = i18n.months[month];
        if (win.store.state.rtl) {
            return monthName +' '+day+' '+dayName; 
        } else {
            return (win.calendar.isUSdate()) ? dayName+', '+monthName+' '+day : dayName+' '+day+' '+monthName;
        }
    }
};

window.calendar.addCalendars = function($checkInText, $checkOutText, config) {
    config = config ? config : {};

    function setSelectedValue(selectObj, valueToSet) {
        for (var i = 0; i < selectObj.options.length; i++) {
            if (selectObj.options[i].value == valueToSet) {
                selectObj.options[i].selected = true;
                return;
            }
        }
    }
    function updateSyncCalendar(startDate, endDate) {
        if (config.sync) {
            calendar.setSyncedCalendars({ start: startDate, end: endDate});
        }
    }
    function scrollToCalendar(calendarEl, isMobile) {
        var windowHeight = Math.max(html.clientHeight, win.innerHeight || 0),
            delay = (isMobile) ? 350 : 50,
            margin = 10;
        win.setTimeout( function() {
            var calendarBottomPos = windowHeight - (calendarEl.getBoundingClientRect().bottom + margin);
            if (calendarBottomPos < 0) $d.scrollto({distance: -calendarBottomPos }); 
        }, delay);
    }
    
    var addedCheckIn = false,
        addedCheckOut = false,
        addDays = win.calendar.addDays,
        diffDays = win.calendar.diffDays,
        parseDate = win.calendar.parseDate,
        updateSharedState = win.calendar.updateSharedState,
        sharedState = win.store.state,
        daysOfStayLimitMin = 1,
        daysOfStayLimitMax = win.calendar.daysOfStayLimitMax,
        today = win.calendar.today(), // parseDate(dL0.currentDate),
        tomorrow = win.calendar.tomorrow(),
        dayAfterTomorrow = win.calendar.dayAfterTomorrow(),
        maxFutureDays = win.calendar.maxFutureDays,
        maxCheckoutDate = addDays(today,maxFutureDays),
        isUSdate = win.calendar.isUSdate(),
        europeanCountriesAndChina = 'al_ad_am_at_by_be_ba_bg_ch_cy_cz_de_dk_ee_es_fo_fi_fr_gb_ge_gi_gr_hu_hr_ie_is_it_lt_lu_lv_mc_mk_mt_no_nl_po_pt_ro_ru_se_si_sk_sm_tr_ua_va_cn',
        firstDay = (europeanCountriesAndChina.indexOf(sharedState.country) !== -1) ? 1 : 0,
        // i18n = window.i18n || {};
        range = win.calendar.getDatesFromShareState(),
        startDate = range.start,
        endDate = range.end;

    if (diffDays(startDate, endDate) > daysOfStayLimitMax) {
        endDate = addDays(startDate, daysOfStayLimitMax);
    }
       
    // Create the events.
    var openDateEvent = new Event('pikaday-open', { bubbles: true });
        selectDateEvent = new Event('pikaday-select', { bubbles: true });
        pikadayReadyEvent = new Event('pikaday-ready', { bubbles: true });
        closeDateEvent = new Event('pikaday-close', { bubbles: true});
        suppressEvent = false;

    var nights = daysOfStayLimitMin,
        numberOfMonths = isMobile ? 1 : 2,
        reposition = !isMobile,
        startPicker,
        endPicker,
        updateRanges = function() {
            startPicker.setRange({start: startDate, end: endDate});
            endPicker.setRange({start: startDate, end: endDate});
        },
        updateStartDate = function() {
            suppressEvent = true;
            endPicker.setMinDate(addDays(startDate, daysOfStayLimitMin));
            var endPickerMax = diffDays(startDate, maxCheckoutDate) < daysOfStayLimitMax ? maxCheckoutDate : addDays(startDate, daysOfStayLimitMax); 
            endPicker.setMaxDate(endPickerMax);

            if (endDate && startDate >= endDate ) {
                endDate = addDays(startDate, nights);
                endPicker.setDate(endDate);
            } else {
                // update nights if enddate does need updating
                if (endDate) nights = diffDays(startDate, endDate);
            }
            if (endDate && diffDays(startDate, endDate) > daysOfStayLimitMax) {
                endDate = addDays(startDate, daysOfStayLimitMax);
                endPicker.setDate(endDate);
            }
            updateRanges();
            suppressEvent = false;
        },
        updateEndDate = function() {
            updateRanges();
        };

    startPicker = new win.Pikaday({
        field: $checkInText,
        numberOfMonths: numberOfMonths,
        defaultDate : startDate,
        setDefaultDate : true,
        startRange : startDate,
        endRange: endDate,
        minDate: today,
        maxDate: addDays(today, maxFutureDays - daysOfStayLimitMin),
        reposition: reposition,
        i18n: i18n,
        isRTL: win.store.state.rtl,
        onSelect: function() {
            startDate = this.getDate();
            updateStartDate();
            updateSharedState(startDate, endDate);
            updateSyncCalendar(startDate, endDate);
            if (!suppressEvent) $checkInText.dispatchEvent(selectDateEvent);
        },
        onOpen: function() {
          if (startDate.getFullYear() != (new Date()).getFullYear()) this.gotoYear(startDate.getFullYear());
          if (!win.pikadayPreventscroll) {
            scrollToCalendar(this.el, isMobile);
          }
          this.gotoYear(this.getDate().getFullYear());
          $checkInText.dispatchEvent(openDateEvent);
          $checkInText.parentElement.classList.add('active');
        },
        onClose: function() {
            $checkInText.parentElement.classList.remove('active');
            $checkInText.dispatchEvent(closeDateEvent);
        },
        isUSdate: isUSdate,
        heading: i18n.calenderHeadings[0],
        firstDay: firstDay
    });
    endPicker = new win.Pikaday({
        field: $checkOutText,
        numberOfMonths: numberOfMonths,
        defaultDate : endDate,
        setDefaultDate : true,
        startRange : startDate,
        endRange: endDate,
        minDate: addDays(startDate, daysOfStayLimitMin),
        maxDate: addDays(startDate, daysOfStayLimitMax),
        reposition: reposition,
        i18n : i18n,
        mainCalendar : 'right',
        isRTL: win.store.state.rtl,
        onSelect: function() {
            endDate = this.getDate();
            nights = diffDays(startDate, endDate);
            updateEndDate();
            updateSharedState(startDate, endDate);
            updateSyncCalendar(startDate, endDate);
            if (!suppressEvent) $checkOutText.dispatchEvent(selectDateEvent);
        },
        onOpen: function() {
          if (numberOfMonths > 1) {
              this.gotoYear(startPicker.getDate().getFullYear());
              this.gotoMonth(startPicker.getDate().getMonth()); // works because shortest month has exactly 28 months, equal to the max stay time
          }
          scrollToCalendar(this.el, isMobile); 
          $checkOutText.parentElement.classList.add('active');
          $checkOutText.dispatchEvent(openDateEvent);
        },
        onClose: function() {
            $checkOutText.parentElement.classList.remove('active');
            $checkOutText.dispatchEvent(closeDateEvent);
        },
        isUSdate: isUSdate,
        heading: i18n.calenderHeadings[1],
        firstDay: firstDay
    });

    updateSharedState(startDate, endDate);

    body.dispatchEvent(pikadayReadyEvent);

    $d.forEach(document.querySelectorAll('.date-text-wrap > .calendar-icon'), function($el) {
        $el.addEventListener('click', function(event) {
            var target = event.target || event.srcElement;
            target.parentElement.querySelector('input').focus();
        });
    });

    var pickers = {
        start: startPicker, 
        end: endPicker 
    };
    if (config.sync) { 
        var currentSync = win.store.state.syncCalendars;
        currentSync.push(pickers);
        win.store.set('syncCalendars', currentSync);
    }

    return pickers;
        
};
